var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M12.833 13.101c-.14.444-.492.828-.957.828-.473 0-.867-.389-.798-.857a2.48 2.48 0 0 1 .345-.985c.151-.237.351-.472.6-.705.208-.188.39-.368.546-.538.155-.17.277-.345.366-.524.089-.184.133-.388.133-.612 0-.26-.04-.475-.12-.645a.817.817 0 0 0-.346-.396 1.108 1.108 0 0 0-.573-.135c-.19 0-.368.043-.533.128a.994.994 0 0 0-.406.376c-.2.333-.47.672-.858.672h-.249c-.54 0-1-.455-.83-.968a2.28 2.28 0 0 1 .266-.55 2.42 2.42 0 0 1 1.085-.894A3.783 3.783 0 0 1 12.03 7c.622 0 1.155.103 1.598.31.444.2.784.499 1.02.893.235.39.352.865.352 1.425 0 .39-.075.737-.226 1.041-.151.3-.349.58-.593.84s-.513.53-.806.807c-.253.228-.426.468-.519.719a2.053 2.053 0 0 0-.022.066Zm-2.016 2.904c0-.286.098-.524.293-.712.196-.193.458-.289.786-.289.324 0 .584.096.78.289a.94.94 0 0 1 .299.712c0 .278-.1.513-.3.706-.195.193-.455.289-.779.289-.328 0-.59-.096-.786-.289a.953.953 0 0 1-.293-.706Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    fillRule: "evenodd",
    d: "M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Zm0 1.5c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
    clipRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/Notice.068545892dfef9286ffc503bfb59e233.svg";
export { ForwardRef as ReactComponent };